export const translations = {
  en: {
    title: 'Please upload your insurance card (Optional).',
    subTitle: 'Upload Primary Insurance',
    text1: 'of Insurance Card',
    text2: 'Click here to upload file',
    Front: 'Front',
    Back: 'Back',
    errorMessage: 'File size limit is 10MB',
    MES029: 'Attachment Guard Error',
    MES030: 'Error extracting request in interceptor',
    MES026: 'Cannot upload more than 1 file',
    MES018: 'Size of file cannot be 0 bytes',
    MES027: 'Cannot upload file of size > 10 mb',
    MES024: 'Mime type is not supported',
    MES023: 'Extension is not supported',
    MES025: 'Special characters in fileName are not allowed',
    MES015: 'Unable to upload and scan attachment'
  },
  es: {
    title: 'Por favor, proporcione fotos de su tarjeta de seguro (Opcional).',
    subTitle: 'Seguro primario',
    text1: 'su tarjeta de seguro',
    text2: 'Haga clic aquí para cargar archivo',
    Front: 'Frente de',
    Back: 'Parte de atrás de',
    errorMessage: 'El límite del tamaño del archivo es de 10 MB',
    MES029: 'Error de protección de archivos adjuntos',
    MES030: 'Error al extraer la solicitud en el interceptor',
    MES026: 'No se puede cargar más de 1 archivo',
    MES018: 'El tamaño del archivo no puede ser de 0 bytes',
    MES027: 'No se puede cargar un archivo de tamaño superior a 10 mb',
    MES024: 'El tipo de MIME no es compatible',
    MES023: 'La extensión no es compatible',
    MES025: 'No se permiten caracteres especiales en el nombre del archivo',
    MES015: 'No se puede cargar y escanear archivos adjuntos'
  }
};
